import { render, staticRenderFns } from "./events-data-table.vue?vue&type=template&id=3555cb7e&scoped=true"
import script from "./events-data-table.vue?vue&type=script&lang=js"
export * from "./events-data-table.vue?vue&type=script&lang=js"
import style0 from "./events-data-table.vue?vue&type=style&index=0&id=3555cb7e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3555cb7e",
  null
  
)

export default component.exports